function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#717171",
  d: "M.869 1.739h8.262a.87.87 0 000-1.739H.869a.87.87 0 000 1.739z"
});

function SvgMinusSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 1.739,
    viewBox: "0 0 10 1.739"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxLjczOSIgdmlld0JveD0iMCAwIDEwIDEuNzM5Ij4KICAgIDxnPgogICAgICAgIDxwYXRoIGZpbGw9IiM3MTcxNzEiIGQ9Ik0uODY5IDU1LjMzMWg4LjI2MmEuODY5Ljg2OSAwIDAgMCAwLTEuNzM5SC44NjlhLjg2OS44NjkgMCAwIDAgMCAxLjczOXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTUzLjU5MikiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgMinusSign as ReactComponent };